import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Product } from './pages/Product';
import { Cart } from './pages/Cart';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlyq8f4bimji">
      <CartProvider data-id="element-1" data-mp="2rlfb1661yc96">
        <Routes data-id="element-2" data-mp="2rikn34nty9b0">
          <Route element={<SiteLayout data-id="element-4" data-mp="2mmcc83go129n" />} data-id="element-3" data-mp="2mm2m8fvmev3y">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mjpvbd7vxaer" />} data-id="element-5" data-mp="2mn5a0exnchfn" />
            <Route path="/shop" element={<Shop data-id="element-8" data-mp="31ayqs2ygxpzt" />} data-id="element-7" data-mp="31aqf2ee30qq7" />
            <Route path="/shop/:category" element={<Shop data-id="element-10" data-mp="31cjk5p91r2w3" />} data-id="element-9" data-mp="31c9vc4zqn1rz" />
            <Route path="/deals" element={<Shop deals data-id="element-12" data-mp="2wj8ehrfz0s5r" />} data-id="element-11" data-mp="2wjgp1comflds" />
            <Route path="/product/:id" element={<Product data-id="element-14" data-mp="28tw62tsgwo4i" />} data-id="element-13" data-mp="2whxbhtucnofp" />
            <Route path="/cart" element={<Cart data-id="element-16" data-mp="28skzynbjv4a8" />} data-id="element-15" data-mp="28te3zgj4jfoo" />
            <Route path="*" element={<NotFound data-id="element-18" data-mp="23vul23bheeqe" />} data-id="element-17" data-mp="23vck4tdvjcc5" />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>;
}